module.exports = __webpack_public_path__ + "static/media/light-motion-constellation-simulation.da80fa5.mp4";